import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationReleasesGet = {
    path: "/releases",
    method: ERouteHttpVerb.GET
};
export { routeLocationReleasesGet };
